import { useState, useEffect, useContext } from 'react';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import InnerFormSection from 'components/ui-components/forms/InnerFormSection';
import HookFormSelect from 'components/cef_form/hook-form/HookFormSelect';
import validateSelectDropdown from 'utils/hook-form/validateSelectDropdown';
import TextLoader from 'components/ui-components/loaders/TextLoader';

const BusinessTypeSelector = ({ businessTypeData }) => {
  const {
    watchedFields: { businessType },
  } = useContext(HookFormContext);

  const [errorMessage, setErrorMessage] = useState('');
  // TODO: File with all error message strings?
  const businessTypePlaceholder = 'Please select an option';
  const businessTypeError = 'Please select a business type';

  useEffect(() => {
    if (!businessTypeData.length) {
      setErrorMessage('An error occurred while fetching Business Type data');
    }
  }, [businessTypeData]);

  return (
    <InnerFormSection>
      {businessTypeData.length && businessTypeData[0] === 'loading' && (
        <TextLoader />
      )}

      {businessTypeData[0] !== 'loading' && businessTypeData.length && (
        <HookFormSelect
          variant="feature"
          id="customer.business_type"
          label="Business Type"
          placeholder={businessTypePlaceholder}
          selectItems={businessTypeData}
          value={businessType}
          rules={{
            required: businessTypeError,
            validate: validateSelectDropdown(
              businessTypePlaceholder,
              businessTypeError,
            ),
          }}
        />
      )}

      {/* TODO: Proper API failure functionality - this is temporary */}
      {!businessTypeData.length && (
        <div className="alert error">
          {errorMessage || 'An error occurred: Cannot display field'}
        </div>
      )}
    </InnerFormSection>
  );
};

export default BusinessTypeSelector;
